import { Tiers, MembershipBucket, ProductNames } from './SubscriptionsModels';
import {MembershipPage} from '../helpers/plans';

export type LeadingFeatures = string[] | Partial<Record<MembershipPage, string[]>>;
export type LeadingDuration = string | Partial<Record<MembershipPage, string>>

export type Feature = { text: string; icon: string; isAvailable: boolean };
export type BaseFeature = { text: string; icon: string; availableFor: ProductNames[] };

export const BASE_FEATURES: BaseFeature[] = [
    { text: 'Daily Domestic Economy Deals', icon: 'pi pi-check', availableFor: [ProductNames.Premium, ProductNames.PremiumPlus] },
    { text: 'Daily International Economy Deals', icon: 'pi pi-check', availableFor: [ProductNames.Premium, ProductNames.PremiumPlus] },
    { text: 'Exclusive Club Only Deals',       icon: 'pi pi-check', availableFor: [ProductNames.PremiumPlus] },
    { text: 'Business & Premium Class',        icon: 'pi pi-check', availableFor: [ProductNames.PremiumPlus] },
    { text: 'Exclusive Travel Perks & Discounts', icon: 'pi pi-check', availableFor: [ProductNames.PremiumPlus] },
    { text: 'Dream Destination Alerts (Instant SMS)', icon: 'pi pi-check', availableFor: [ProductNames.PremiumPlus] },
];

export const SOLO_PREMIUM_PLUS_FEATURES: Feature[] = [
    { text: 'Instant Club Access', icon: 'pi pi-check', isAvailable: true },
    { text: 'Save up to 90% on every flight', icon: 'pi pi-check', isAvailable: true },
    { text: 'Save 20+ hours/year hunting deals', icon: 'pi pi-check', isAvailable: true },
    { text: 'Domestic & International economy', icon: 'pi pi-check', isAvailable: true },
    { text: 'Business & Premium Class', icon: 'pi pi-check', isAvailable: true },
    { text: 'Exclusive Travel Perks & Discounts', icon: 'pi pi-check', isAvailable: true },
    { text: 'Dream Destination Alerts (SMS + Email)', icon: 'pi pi-check', isAvailable: true },
];


export interface PlanDef {
    tier: Tiers;
    membership: MembershipBucket;
    name: ProductNames;
    price: number | null;
    defaultDuration: LeadingDuration;
    buttonClass: string;
    isPopular: boolean;
    features: LeadingFeatures;
    forceAllBaseAvailable?: boolean;
};


export const PLAN_DEFS: readonly PlanDef[] = [
    {
        tier: Tiers.Free,
        membership: MembershipBucket.Free,
        name: ProductNames.Basic,
        price: null,
        defaultDuration: {
            upgrade: '',
            signup: 'Waitlist'
        },
        buttonClass: 'p-button-outlined p-button-secondary',
        isPopular: false,
        features: {
            upgrade: ['Deal Frequency: Limited'],
            signup:  ['Join Waitlist (est. wait: 2-3 months)', 'Deal Frequency: Limited'],
        },    },
    {
        tier: Tiers.Premium,
        membership: MembershipBucket.Premium,
        name: ProductNames.Premium,
        price: 69,
        defaultDuration: {
            upgrade: '',
            signup: 'Instant Access'
        },
        buttonClass: 'p-button-primary',
        isPopular: true,
        features: {
            upgrade: ['Deal Frequency: High'],
            signup: ['Instant Club Access', 'Deal Frequency: High'],
        }
    },
    {
        tier: Tiers.PremiumPlus,
        membership: MembershipBucket.PremiumPlus,
        name: ProductNames.PremiumPlus,
        price: 99,
        defaultDuration: {
            upgrade: '',
            signup: 'Instant Access'
        },
        buttonClass: 'p-button-primary',
        isPopular: true,
        features: {
            upgrade: ['Deal Frequency: High'],
            signup: ['Instant Club Access', 'Deal Frequency: High'],
        },
        forceAllBaseAvailable: true,
    },
];
export function featuresForPlan(
    planName: ProductNames,
    baseFeatures: BaseFeature[] = BASE_FEATURES,
    forceAll = false
): Feature[] {
    return baseFeatures.map(f => {
        const available = forceAll || f.availableFor.includes(planName);
        return {
            text: f.text,
            icon: available ? f.icon : 'pi pi-times',
            isAvailable: available,
        };
    });
}
